import React from "react";
import { Link } from "react-router-dom";
import { openCookieSettings } from "@/lib/consent";
import useLegalInfo from "@/hooks/useLegalInfo";

export const LEGAL_LINKS = [
  { to: "/aviso-legal", label: "Aviso legal" },
  { to: "/politica-de-privacidad", label: "Privacidad" },
  { to: "/politica-de-cookies", label: "Cookies" },
];

export function LegalLinks({ className = "", itemClass = "hover:text-white" }) {
  return (
    <div className={className} data-testid="legal-links">
      {LEGAL_LINKS.map((l) => (
        <Link key={l.to} to={l.to} className={itemClass} data-testid={`legal-link-${l.to.slice(1)}`}>{l.label}</Link>
      ))}
      <button type="button" onClick={openCookieSettings} className={`${itemClass} text-left`} data-testid="legal-link-cookie-settings">
        Configurar cookies
      </button>
    </div>
  );
}

export function PrivacyFirstLayer({ purpose = "gestionar tu cuenta y prestarte el servicio contratado" }) {
  const { L } = useLegalInfo();
  return (
    <div className="text-[11px] leading-relaxed text-slate-500 border border-slate-200 bg-slate-50 p-3" data-testid="privacy-first-layer">
      <strong className="text-slate-700">Información básica sobre protección de datos.</strong>{" "}
      <strong>Responsable:</strong> {L("company_name").replace(/\.$/, "")}. <strong>Finalidad:</strong> {purpose}.{" "}
      <strong>Legitimación:</strong> consentimiento y ejecución del contrato. <strong>Destinatarios:</strong> no se ceden datos a terceros salvo obligación legal o proveedores necesarios (hosting, pagos).{" "}
      <strong>Derechos:</strong> acceso, rectificación, supresión, oposición, limitación y portabilidad en {L("email")}.{" "}
      <strong>Más información:</strong> <Link to="/politica-de-privacidad" target="_blank" className="text-orange-600 underline">Política de Privacidad</Link>.
    </div>
  );
}

export function PrivacyCheckbox({ checked, onChange, testid }) {
  return (
    <label className="flex items-start gap-3 cursor-pointer text-sm text-slate-700">
      <input type="checkbox" required checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid}
        className="mt-0.5 w-5 h-5 accent-orange-600 shrink-0" />
      <span>
        He leído y acepto la{" "}
        <Link to="/politica-de-privacidad" target="_blank" className="text-orange-600 font-semibold underline">Política de Privacidad</Link>
        <span className="text-red-600"> *</span>
      </span>
    </label>
  );
}
